module.exports = __webpack_public_path__ + "img/buy.3a2b02bd.svg";